module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/chart-line-1-06419d326a56fb019dc0e0093cf9e933.svg";